/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument */
// @ts-nocheck

export const createBase = (initialValues) => {
  const env = Object.assign({}, initialValues);
  const base = () => {};

  Object.keys(env).forEach((key) => {
    base[key] = (...args) => {
      if (!args.length) {
        return env[key];
      }
      env[key] = args[0];
      return base;
    };
  });

  return base;
};

export function defined(...outerArguments) {
  return function (d, i) {
    for (let c = 0, j = outerArguments.length; c < j; c++) {
      if (outerArguments[c](d, i) == null) {
        return false;
      }
    }
    return true;
  };
}

export const functor = (d) => (typeof d === 'function' ? d : () => d);
